import styled, { css, keyframes } from "styled-components";
import { colors } from "@streeteasy/design-system";

const save = keyframes`
  0% {
    opacity: 0;
  }
  1% {
    opacity: 0;
  }
  2% {
    background: linear-gradient(
      0deg,
      rgba(24, 118, 219, 0) 13.9%,
      rgba(24, 118, 219, 1) 14%,
      rgba(24, 118, 219, 1) 17.4%,
      rgba(24, 118, 219, 0) 17.5%,
      rgba(24, 118, 219, 0) 50%,
      rgba(24, 118, 219, 0) 82.5%,
      rgba(24, 118, 219, 1) 82.6%,
      rgba(24, 118, 219, 1) 85.6%,
      rgba(24, 118, 219, 0) 85.7%
    );
    opacity: 1;
  }
  20% {
    background: linear-gradient(
      0deg,
      rgba(24, 118, 219, 0) 10.9%,
      rgba(24, 118, 219, 1) 11%,
      rgba(24, 118, 219, 1) 17.4%,
      rgba(24, 118, 219, 0) 17.5%,
      rgba(24, 118, 219, 0) 50%,
      rgba(24, 118, 219, 0) 82.5%,
      rgba(24, 118, 219, 1) 82.6%,
      rgba(24, 118, 219, 1) 88.6%,
      rgba(24, 118, 219, 0) 88.7%
    );
    opacity: 1;
  }
  40% {
    background: linear-gradient(
      0deg,
      rgba(24, 118, 219, 0) 7.9%,
      rgba(24, 118, 219, 1) 8%,
      rgba(24, 118, 219, 1) 17.4%,
      rgba(24, 118, 219, 0) 17.5%,
      rgba(24, 118, 219, 0) 50%,
      rgba(24, 118, 219, 0) 82.5%,
      rgba(24, 118, 219, 1) 82.6%,
      rgba(24, 118, 219, 1) 91.6%,
      rgba(24, 118, 219, 0) 91.7%
    );
    opacity: 1;
  }
  60% {
    background: linear-gradient(
      0deg,
      rgba(24, 118, 219, 0) 4.9%,
      rgba(24, 118, 219, 1) 5%,
      rgba(24, 118, 219, 1) 14.4%,
      rgba(24, 118, 219, 0) 14.5%,
      rgba(24, 118, 219, 0) 50%,
      rgba(24, 118, 219, 0) 85.5%,
      rgba(24, 118, 219, 1) 85.6%,
      rgba(24, 118, 219, 1) 94.6%,
      rgba(24, 118, 219, 0) 94.7%
    );
    opacity: 1;
  }
  80% {
    background: linear-gradient(
      0deg,
      rgba(24, 118, 219, 0) 4.9%,
      rgba(24, 118, 219, 1) 5%,
      rgba(24, 118, 219, 1) 11.4%,
      rgba(24, 118, 219, 0) 11.5%,
      rgba(24, 118, 219, 0) 50%,
      rgba(24, 118, 219, 0) 88.5%,
      rgba(24, 118, 219, 1) 88.6%,
      rgba(24, 118, 219, 1) 94.6%,
      rgba(24, 118, 219, 0) 94.7%
    );
    opacity: 1;
  }
  99% {
    background: linear-gradient(
      0deg,
      rgba(24, 118, 219, 0) 0%,
      rgba(24, 118, 219, 1) 0.1%,
      rgba(24, 118, 219, 1) 3.1%,
      rgba(24, 118, 219, 0) 3.2%,
      rgba(24, 118, 219, 0) 50%,
      rgba(24, 118, 219, 0) 96.8%,
      rgba(24, 118, 219, 1) 96.9%,
      rgba(24, 118, 219, 1) 99.9%,
      rgba(24, 118, 219, 0) 100%
    );
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const unsave = keyframes`
  0% {
    opacity: 0;
  }
  1% {
    opacity: 0;
  }
  2% {
    background: linear-gradient(0deg, rgba(24,118,219,0) 0%, rgba(24,118,219,1) 0.1%, rgba(24,118,219,1) 3.1%, rgba(24,118,219,0) 3.2%, rgba(24,118,219,0) 50%, rgba(24,118,219,0) 96.8%, rgba(24,118,219,1) 96.9%, rgba(24,118,219,1) 99.9%, rgba(24,118,219,0) 100%);
    opacity: 1;
  }
  20% {
    background: linear-gradient(0deg, rgba(24,118,219,0) 4.9%, rgba(24,118,219,1) 5%, rgba(24,118,219,1) 11.4%, rgba(24,118,219,0) 11.5%, rgba(24,118,219,0) 50%, rgba(24,118,219,0) 88.5%, rgba(24,118,219,1) 88.6%, rgba(24,118,219,1) 94.6%, rgba(24,118,219,0) 94.7%);
    opacity: 1;
  }
  40% {
    background: linear-gradient(0deg, rgba(24,118,219,0) 4.9%, rgba(24,118,219,1) 5%, rgba(24,118,219,1) 14.4%, rgba(24,118,219,0) 14.5%, rgba(24,118,219,0) 50%, rgba(24,118,219,0) 85.5%, rgba(24,118,219,1) 85.6%, rgba(24,118,219,1) 94.6%, rgba(24,118,219,0) 94.7%);
    opacity: 1;
  }
  60% {
    opacity: 1;
    background: linear-gradient(0deg, rgba(24,118,219,0) 7.9%, rgba(24,118,219,1) 8%, rgba(24,118,219,1) 17.4%, rgba(24,118,219,0) 17.5%, rgba(24,118,219,0) 50%, rgba(24,118,219,0) 82.5%, rgba(24,118,219,1) 82.6%, rgba(24,118,219,1) 91.6%, rgba(24,118,219,0) 91.7%);
  }
  80% {
    background: linear-gradient(0deg, rgba(24,118,219,0) 10.9%, rgba(24,118,219,1) 11%, rgba(24,118,219,1) 17.4%, rgba(24,118,219,0) 17.5%, rgba(24,118,219,0) 50%, rgba(24,118,219,0) 82.5%, rgba(24,118,219,1) 82.6%, rgba(24,118,219,1) 88.6%, rgba(24,118,219,0) 88.7%);
    opacity: 1;
  }
  99% {
    background: linear-gradient(0deg, rgba(24,118,219,0) 13.9%, rgba(24,118,219,1) 14%, rgba(24,118,219,1) 17.4%, rgba(24,118,219,0) 17.5%, rgba(24,118,219,0) 50%, rgba(24,118,219,0) 82.5%, rgba(24,118,219,1) 82.6%, rgba(24,118,219,1) 85.6%, rgba(24,118,219,0) 85.7%);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const heartStroke = keyframes`
  0% {
    font-size: 22px;
  }
  50% {
    font-size: 26px;
  }
  100% {
    font-size: 22px;
  }
`;

const heartEmpty = keyframes`
  0% {
    font-size: 22px;
    opacity: 1;
  }
  50% {
    font-size: 26px;
    opacity: 0;
  }
  100% {
    font-size: 22px;
    opacity: 0;
  }
`;

const heartFilled = keyframes`
  0% {
    font-size: 22px;
    opacity: 0;
  }
  50% {
    font-size: 26px;
    opacity: 1;
  }
  100% {
    font-size: 22px;
    opacity: 1;
  }
`;

export const ListingSaveLine = styled.span`
  background: linear-gradient(
    0deg,
    rgba(24, 118, 219, 0) 13.9%,
    rgba(24, 118, 219, 1) 14%,
    rgba(24, 118, 219, 1) 17.4%,
    rgba(24, 118, 219, 0) 17.5%,
    rgba(24, 118, 219, 0) 50%,
    rgba(24, 118, 219, 0) 82.5%,
    rgba(24, 118, 219, 1) 82.6%,
    rgba(24, 118, 219, 1) 85.6%,
    rgba(24, 118, 219, 0) 85.7%
  );
  height: 62px;
  left: 14px;
  opacity: 0;
  position: absolute;
  top: -18px;
  width: 1px;
  z-index: 3;

  &:nth-child(2) {
    transform: rotate(90deg);
  }

  &:nth-child(3) {
    transform: rotate(45deg);
  }

  &:nth-child(4) {
    transform: rotate(135deg);
  }
`;

export const SaveButton = styled.button`
  align-items: center;
  background-color: ${colors.WHITE};
  border: none;
  display: block;
  height: 30px;
  justify-content: center;
  width: 30px;

  &::before {
    color: ${colors.BRAND};
    content: "\f08a";
    display: block;
    font-family: FontAwesome;
    font-size: 22px;
    left: 50%;
    line-height: 16px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &::after {
    transition: opacity 0.3s ease-in-out;
    color: ${colors.BRAND};
    content: "\f004";
    display: inline-block;
    font-family: FontAwesome;
    font-size: 22px;
    left: 50%;
    line-height: 16px;
    opacity: 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &:not(:focus) {
    outline: none;
  }

  ${props =>
    props.isSaved &&
    css`
      &:before {
        content: "\f004";
      }
    `}

    ${props =>
      !props.isSaved &&
      css`
        &:before {
          content: "\f08a";
        }
      `}

  ${props =>
    props.behavior === "toBeUnsaved" &&
    css`
      &:before {
        color: ${colors.BRAND};
        content: "\f08a";
        animation-name: ${heartStroke};
        animation-duration: 0.3s;
        animation-timing-function: ease;
      }

      &:after {
        animation-name: ${heartEmpty};
        animation-duration: 0.2s;
        animation-timing-function: ease;
      }

      ${ListingSaveLine} {
        background: linear-gradient(
          0deg,
          rgba(24, 118, 219, 0) 0%,
          rgba(24, 118, 219, 1) 0.1%,
          rgba(24, 118, 219, 1) 3.1%,
          rgba(24, 118, 219, 0) 3.2%,
          rgba(24, 118, 219, 0) 50%,
          rgba(24, 118, 219, 0) 96.8%,
          rgba(24, 118, 219, 1) 96.9%,
          rgba(24, 118, 219, 1) 99.9%,
          rgba(24, 118, 219, 0) 100%
        );
        animation-name: ${unsave};
        animation-duration: 0.2s;
        animation-timing-function: ease-in;
      }

      &:focus,
      &:focus-within {
        outline: none;

        ${ListingSaveLine} {
          height: 62px;
          outline: none;
        }
      }

      &:hover {
        color: ${colors.BRAND_DARK};
      }
    `}

    ${props =>
      props.behavior === "toBeSaved" &&
      css`
        &:before {
          color: ${colors.BRAND};
          content: "\f004";
          animation-name: ${heartStroke};
          animation-duration: 0.3s;
          animation-timing-function: ease;
        }

        &:after {
          animation-name: ${heartFilled};
          animation-duration: 0.2s;
          animation-timing-function: ease;
        }

        ${ListingSaveLine} {
          animation-name: ${save};
          animation-duration: 0.2s;
          animation-timing-function: ease-in;
        }

        &:focus,
        &:focus-within {
          outline: none;

          ${ListingSaveLine} {
            height: 62px;
            outline: none;
          }
        }

        &:hover {
          color: ${colors.BRAND_DARK};
        }
      `}
`;

export const SaveButtonWrapper = styled.div`
  position: relative;
`;
